import { ExportedReportItem, CreateExportedReport, EmailExportedReport } from '@futrli-sdk/report_scheduling';
import { API_PATHS, interpolatePathParams, REQUEST_METHODS, ROUTE_PARAMS } from '@futrli/shared-services';

import { makeRequestWithResponse } from '../shared';

export const getExportedReports = async (
  workspaceId: string,
  organisationId: string,
  consolidation = false
): Promise<ExportedReportItem[]> => {
  const path = consolidation ? API_PATHS.REPORT_EXPORTED_CONSOLIDATION : API_PATHS.REPORT_EXPORTED;
  const url = interpolatePathParams(path, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse({ url, method: REQUEST_METHODS.GET });
};

export const deleteExportedReport = async (
  workspaceId: string,
  organisationId: string,
  exportedReportId: string,
  consolidation = false
): Promise<void> => {
  const path = consolidation ? API_PATHS.REPORT_EXPORTED_BY_ID_CONSOLIDATION : API_PATHS.REPORT_EXPORTED_BY_ID;
  const url = interpolatePathParams(path, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.EXPORTED_REPORT_ID]: exportedReportId
  });

  return makeRequestWithResponse({ url, method: REQUEST_METHODS.DELETE });
};

export const getExportedReportDetails = async (
  workspaceId: string,
  organisationId: string,
  exportedReportId: string,
  consolidation = false
): Promise<ExportedReportItem> => {
  const path = consolidation ? API_PATHS.REPORT_EXPORTED_BY_ID_CONSOLIDATION : API_PATHS.REPORT_EXPORTED_BY_ID;
  const url = interpolatePathParams(path, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.EXPORTED_REPORT_ID]: exportedReportId
  });

  return makeRequestWithResponse({ url, method: REQUEST_METHODS.GET });
};

export const createExportedReport = (
  workspaceId: string,
  organisationId: string,
  data: CreateExportedReport,
  consolidation = false
): Promise<ExportedReportItem> => {
  const path = consolidation ? API_PATHS.REPORT_EXPORTED_CONSOLIDATION : API_PATHS.REPORT_EXPORTED;
  const url = interpolatePathParams(path, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse({ url, method: REQUEST_METHODS.POST, data });
};

export const emailExportedReport = (
  workspaceId: string,
  organisationId: string,
  exportedReportId: string,
  data: EmailExportedReport,
  consolidation = false
): Promise<void> => {
  const path = consolidation ? API_PATHS.EMAIL_EXPORTED_REPORT_CONSOLIDATION : API_PATHS.EMAIL_EXPORTED_REPORT;
  const url = interpolatePathParams(path, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.EXPORTED_REPORT_ID]: exportedReportId
  });

  return makeRequestWithResponse({ url, method: REQUEST_METHODS.POST, data });
};
